import { Navigate } from "react-router-dom";
import { COMMITTEES_ACTIVE_PATH } from "./constants";
import { useNatlCommitteeManagementGate } from "./useNatlCommitteeManagementEnabled";
import LegacyCommitteesRedirect from "./_LegacyCommitteesRedirect";

export default function CommitteesIndexPage() {
  const { enabled, flagsLoaded } = useNatlCommitteeManagementGate();

  if (!flagsLoaded) {
    return null;
  }

  if (enabled) {
    return <Navigate to={COMMITTEES_ACTIVE_PATH} replace />;
  }

  return <LegacyCommitteesRedirect />;
}
